import {
  afterNextRender,
  Component,
  computed,
  ElementRef,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { ThemeService } from '../services/theme';
import { ResponsiveService } from '../services/responsive';
import { v3LayoutFlags } from '../services/v3-layout';
import { trackContentRead } from '../services/content-read';
import { V3_INFO_PAGE_CONTENT, V3_INFO_PAGE_DISCLAIMER } from './v3-info-page-content';

// The per-tab info page (AI-637), reached from a subpage's info icon — one per analysis tab
// with an article (V3_INFO_PAGE_CONTENT), none for the overview. Rendered by Core inside V3Root
// (section 'info'), so the nav stays on top with that tab active. Main-page card chrome around
// the tab's article.
@Component({
  selector: 'app-v3-info-page',
  templateUrl: './v3-info-page.html',
  styleUrl: './v3-info-page.scss',
  standalone: true,
})
export class V3InfoPage {
  // Tab id of the analysis this page explains (news, earnings, …) — see V3_TAB_LABELS.
  readonly tab = input.required<string>();
  readonly title = input('');
  // Zero only — same per-tab icon as V3ZeroSubpageCard (Core.pageIcon).
  readonly icon = input<string | null>(null);

  private readonly layout = v3LayoutFlags(inject(ThemeService), inject(ResponsiveService));
  readonly isFinnet = this.layout.isFinnet;
  readonly isZeroDesktop = this.layout.isZeroDesktop;
  readonly isFinnetDesktop = this.layout.isFinnetDesktop;

  readonly heading = computed(() => `${this.title()} erklärt`);
  private readonly cardTitle = viewChild.required<ElementRef<HTMLElement>>('cardTitle');
  readonly content = computed(() => V3_INFO_PAGE_CONTENT[this.tab()] ?? null);
  readonly disclaimer = V3_INFO_PAGE_DISCLAIMER;

  constructor() {
    // The focused info icon is gone once this renders — move focus to the heading (Core scrolls
    // to top itself).
    afterNextRender(() => this.cardTitle().nativeElement.focus({ preventScroll: true }));

    // Read event once the article has been open for 5s (AI-646).
    trackContentRead(() => ({
      element_title: 'info_page_read',
      feature_name: 'content_read',
      property: { tab: this.tab() },
    }));
  }
}
